import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { getUsersByCode } from "../../../Services/Pointeuse/UsersApi";
import CustomSyncLoader from "../../Others/CustomSyncLoader";
import ErrorCustum from "../../Others/ErrorCustum";

function PieApexGender() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    const arrayFilter = [];
    getUsersByCode()
      .then((res) => {
        res.data.map((item) => {
          arrayFilter.push(item?.gender);
        });
        const obj = arrayFilter.reduce((prev, curr) => ((prev[curr] = ++prev[curr] || 1), prev), {});
        let chartOptions = {
          series: [obj.male || 0, obj.femele || 0],
          options: {
            chart: {
              // width: 300,
              type: "polarArea",
              sparkline: {
                enabled: true,
              },
            },
            labels: ["Homme", "Femme"],
            fill: {
              opacity: 1,
              colors: ["#22BBFF", "#E0148D"],
            },
            stroke: {
              width: 0,
              colors: undefined,
            },
            yaxis: {
              show: false,
            },
            legend: {
              show: true,
              fontSize: "12px",
              fontWeight: 300,

              labels: {
                colors: "black",
              },
              position: "bottom",
              horizontalAlign: "center",
              markers: {
                width: 19,
                height: 19,
                strokeWidth: 0,
                radius: 19,
                strokeColor: "#fff",
                fillColors: ["#22BBFF", "#E0148D"],
                offsetX: 0,
                offsetY: 0,
              },
            },
            plotOptions: {
              polarArea: {
                rings: {
                  strokeWidth: 0,
                },
              },
            },
            theme: {
              monochrome: {
                enabled: true,
                shadeTo: "light",
                shadeIntensity: 0.6,
              },
            },
          },
        };
        console.log(chartOptions);
        setData(chartOptions);
      })
      .catch((error) => setError(error))
      .finally(() => setLoading(false));
  }, []);
  return (
    <>
      {loading && <CustomSyncLoader></CustomSyncLoader>}
      {!loading && error && <ErrorCustum></ErrorCustum>}
      {!loading && !error && data && (
        <ReactApexChart
          options={data.options}
          series={data.series}
          type="polarArea"
          height={251}
          // width={300}
        />
      )}
    </>
  );
}

export default PieApexGender;
